import {
	CheckUtils,
	ConversationVisibilityVoData,
	ConversationVoData,
	JabberChatStateVoData,
	MessageVoData
} from "od-ts";
import {
	AvatarDataIcon,
	ChatStateData,
	ConversationData,
	DecoratedAvatarData,
	MessageData,
	StatusBadgeData,
	TypeBadgeData,
	TypeConversationData
} from "ui-ts";

export class ChatConverter {

  static convertToMessageData(message: MessageVoData, target?: MessageData): MessageData {
    if (CheckUtils.isEmpty(message)) return null;

    var result = CheckUtils.isEmpty(target) ? new MessageData() : target;
    result.id = message.uid;
    result.createdDate = new Date(message.createdDate);
    result.text = message.data;
    result.valid = message.valid;
    result.isEdited = message.isEdited;
    result.isDeleted = message.isDeleted;

    var avatarData = new AvatarDataIcon();
    (avatarData as AvatarDataIcon).icon = "odi_user";
    (avatarData as AvatarDataIcon).iconColor = "#25aed8";


    result.author = new DecoratedAvatarData();
    result.author.jid=message.authorJabberId;
    result.author.avatarData = avatarData;
    result.author.type = TypeBadgeData.USER;
    result.author.status = StatusBadgeData.OFFLINE;
    return result;
  }

  static convertToMessageVoData(message: MessageData, target?: MessageVoData): MessageVoData {
    if (CheckUtils.isEmpty(message)) return null;

    var result = CheckUtils.isEmpty(target) ? new MessageVoData() : target;
    result.uid = (message as MessageData).id;
    result.createdDate = (message as MessageData).createdDate.getTime();
    result.data = (message as MessageData).text;
    result.valid = message.valid;
    result.isEdited = message.isEdited;
    result.isDeleted = message.isDeleted;
    result.files = [];
    if (!CheckUtils.isEmpty(message.files))
      message.files.forEach(file => result.files.push(file.identityKey));
    return result;
  }

  static convertToConversationData(conversation: ConversationVoData, target?: ConversationData): ConversationData {
    if (conversation == null) return null;

    var result = CheckUtils.isEmpty(target) ? new ConversationData() : target;
    result.id = conversation.uid;
    result.lastMessageDate = new Date(conversation.lastPosted);
    result.read = CheckUtils.isEmpty(conversation.unReadMessagesId);

    switch (conversation.visibility) {
      case ConversationVisibilityVoData.PRIVATE:
        result.type = TypeConversationData.PRIVATE;
        break;
      case ConversationVisibilityVoData.PUBLIC:
        result.type = TypeConversationData.PUBLIC;
        break;
    }
    return result;
  }

  static convertToJabberChatStateVoData(chatState: ChatStateData) {
    switch (chatState) {
      case ChatStateData.GONE:
        return JabberChatStateVoData.GONE;
      case ChatStateData.COMPOSING:
        return JabberChatStateVoData.COMPOSING;
      case ChatStateData.PAUSED:
        return JabberChatStateVoData.PAUSED;
      case ChatStateData.INACTIVE:
      default:
        return JabberChatStateVoData.INACTIVE;
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/converter/chat-converter.ts